<div class="container">
  <header class="blog-header py-3">
    <div class="row justify-content-between align-items-center">
      <div class="col-12 col-sm-4">
        <ul class="list-column">
          <li>
            <a [href]="mainSiteUrl()" target="_self">{{
              'GO_TO_MAIN_SITE' | translate
            }}</a>
          </li>
        </ul>
      </div>
      <div class="col-12 col-sm-4 text-center">
        <a
          class="blog-header-logo"
          [routerLink]="['/'] | localize"
          routerLinkActive="current"
          [routerLinkActiveOptions]="{ exact: true }"
          title="{{ 'GO_TO_HOME' | translate }}"
        >
          <img
            src="../assets/img/logo-light_{{ lang }}.png"
            srcset="../assets/img/logo-light_{{ lang }}@2x.png 2x, ../assets/img/logo-light_{{ lang }}@3x.png 3x"
        /></a>
      </div>
      <div
        class="col-12 col-sm-4 d-flex justify-content-end align-items-center"
      >
        <div class="lang-select-wrap">
          <select
            class="lang-select"
            [attr.aria-label]="'LANGUAGE_SELECT' | translate"
            [value]="languageService.initialLang"
            (change)="onLangSelected($event)"
          >
            @for (item of languageService.availableLangs; track item) {
              <option [value]="item">{{ item | uppercase }}</option>
            }
          </select>
          <fa-icon
            class="header-chevron lang-select-caret"
            [icon]="faChevronDown"
          ></fa-icon>
        </div>

        <div class="ml-3">
          @if (!isSearchOpen) {
            <button
              type="button"
              id="search-trigger"
              class="icon-button"
              [title]="
                !isSearchOpen
                  ? ('SEARCH_OPEN' | translate)
                  : ('SEARCH_CLOSE' | translate)
              "
              [attr.aria-label]="
                !isSearchOpen
                  ? ('SEARCH_OPEN' | translate)
                  : ('SEARCH_CLOSE' | translate)
              "
              (click)="isSearchOpen = !isSearchOpen"
            >
              <fa-icon [icon]="faSearch"></fa-icon>
            </button>
          }
          @if (isSearchOpen) {
            <div class="form-control form-control--sm lh-1 mb-0">
              <input
                [ngModel]="searchQuery"
                #searchModel="ngModel"
                type="search"
                name="search"
                id="search"
                required
                maxlength="255"
                (blur)="searchModel.value?.length ? '' : (isSearchOpen = false)"
                [placeholder]="'MAIN_SEARCH_PLACEHOLDER' | translate"
                [attr.aria-label]="'MAIN_SEARCH' | translate"
                appAutofocus
                debounce
                (debounce)="onSearch(searchModel.value)"
                (search)="onSearch(searchModel.value)"
                (key.enter)="$event.stopPropagation()"
                spellcheck="false"
                required
              />
            </div>
          }
        </div>
      </div>
    </div>
  </header>
  <!-- Main menu -->
  @if (menu().sections?.length > 0 || isInnerUser()) {
    <div class="blog-menu">
      <nav class="nav-fill pb-0">
        <ul class="position-relative d-flex">
          @if (isInnerUser()) {
            <li class="menu-item-wrap">
              <a
                class="menu-item px-2 py-3"
                [routerLink]="['/employees'] | localize"
                routerLinkActive="current"
                target="_self"
                >{{ 'EMPLOYEES_LIST' | translate }}</a
              >
            </li>
          }
          @if (isInnerUser()) {
            <li class="menu-item-wrap">
              <a
                class="menu-item px-2 py-3"
                [routerLink]="['/files'] | localize"
                routerLinkActive="current"
                target="_self"
                >{{ 'DOCUMENTS_PAGE' | translate }}</a
              >
            </li>
          }
          @for (section of menu().sections; track section) {
            @if (section?.items?.length && section.items; as items) {
              @for (item of items; track item) {
                <li
                  dropdown
                  #dropdown="bs-dropdown"
                  placement="bottom"
                  container="body"
                  (mouseenter)="dropdown.show()"
                  (mouseleave)="closeDropdown(dropdown)"
                  class="menu-item-wrap"
                >
                  @if (item.page; as page) {
                    <a
                      class="menu-item px-2 py-3"
                      [routerLink]="['/' + page.pretty_url] | localize"
                      [externalLink]="page.external_url"
                      routerLinkActive="current"
                      [routerLinkActiveOptions]="{ exact: true }"
                      [title]="page.short_content || ''"
                    >
                      <span>{{
                        page.title || page.pretty_url | shorten: 20 : '...'
                      }}</span>
                      @if (item?.children?.length) {
                        <button
                          type="button"
                          dropdownToggle
                          stopPropagation
                          (click)="$event.preventDefault()"
                        >
                          <fa-icon
                            [icon]="faChevronDown"
                            class="header-chevron"
                            [class.rotate-180]="dropdown.isOpen"
                            [fixedWidth]="true"
                          ></fa-icon>
                        </button>
                      }
                    </a>
                    <!-- Nested links -->
                    @if (
                      item?.children?.length && item?.children;
                      as children
                    ) {
                      <ul
                        *dropdownMenu
                        class="header-dropdown shadow"
                        role="menu"
                        (mouseenter)="preventClosingDropdown(dropdown)"
                        (mouseleave)="dropdown.hide()"
                      >
                        @for (child of children; track child) {
                          <li role="menuitem">
                            <a
                              [title]="child.page?.short_content || ''"
                              [routerLink]="
                                ['/' + child.page?.pretty_url] | localize
                              "
                              [externalLink]="child.page?.external_url"
                              (click)="dropdown.hide()"
                              >{{
                                child.page?.title || child.page?.pretty_url
                                  | shorten: 70 : '...'
                              }}</a
                            >
                          </li>
                        }
                      </ul>
                    }
                  }
                </li>
              }
            }
          }
        </ul>
      </nav>
    </div>
  }
</div>
